'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _lodash = require('lodash');

var _selectedElementReducer = require('./selectedElementReducer');

var _selectedElementReducer2 = _interopRequireDefault(_selectedElementReducer);

var _selectionConstants = require('../../common/elements/selectionConstants');

var _userConstants = require('../user/userConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib


// Reducers


// Constants


var initialState = Immutable.Map();

var delegateToSelectedElement = function delegateToSelectedElement(state, action, elementId) {
    return state.set(elementId, (0, _selectedElementReducer2.default)(undefined, action));
};

var delegateToEachSelectedElement = function delegateToEachSelectedElement(state, action) {
    return action.ids.reduce(function (newState, elementId) {
        return delegateToSelectedElement(newState, action, elementId);
    }, state);
};

/**
 * When a user disconnects, remove all of their selected element entries.
 */
var clearSelectedElementsForUser = function clearSelectedElementsForUser(state, action) {
    var userId = action.userId || action.user._id;
    return state.filter(function (selectedElementEntry) {
        return selectedElementEntry.get('userId') !== userId;
    });
};

var loadUserSelectedElements = function loadUserSelectedElements(state, action) {
    var selectedElementIdsMap = (0, _lodash.reduce)(action.users, function (elementIdsMap, activeUserData) {
        var selectedElementIds = activeUserData.selectedElementIds ? activeUserData.selectedElementIds.split(',') : [];
        selectedElementIds.forEach(function (elementId) {
            return elementIdsMap[elementId] = { userId: activeUserData._id };
        });
        return elementIdsMap;
    }, {});

    var userIdsToClear = [].concat(_toConsumableArray((0, _lodash.keys)(action.users)), _toConsumableArray(action.disconnectedUserIds));
    return userIdsToClear.reduce(function (updatedState, userId) {
        return clearSelectedElementsForUser(updatedState, { userId: userId });
    }, state).merge(Immutable.fromJS(selectedElementIdsMap));
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type === _userConstants.USER_NAVIGATE) return clearSelectedElementsForUser(state, action);

    if (action.remote !== true && action.type !== _userConstants.USER_ACTIVITY_LOAD) return state;

    switch (action.type) {
        case _userConstants.USER_ACTIVITY_LOAD:
            return loadUserSelectedElements(state, action);
        case _selectionConstants.ELEMENTS_SELECTED:
        case _selectionConstants.ELEMENTS_DESELECTED:
            return delegateToEachSelectedElement(state, action);
        case _selectionConstants.ELEMENTS_DESELECT_ALL:
            return clearSelectedElementsForUser(state, action);
        case _userConstants.USER_DISCONNECT:
            return clearSelectedElementsForUser(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/remoteActivity/selectedElementsReducer.js
// module id = 2046
// module chunks = 0